module.exports = __webpack_public_path__ + "static/bootstrap-7fc9743ab88e5a7b9a89544a44d4f6d8.png";